import { render, staticRenderFns } from "./Info_2_page.vue?vue&type=template&id=889a698e&scoped=true"
import script from "./Info_2_page.vue?vue&type=script&lang=js"
export * from "./Info_2_page.vue?vue&type=script&lang=js"
import style0 from "./Info_2_page.vue?vue&type=style&index=0&id=889a698e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889a698e",
  null
  
)

export default component.exports